'use client'

import { useState } from 'react'
import { useAuthStore } from '@/stores/auth'
import Navigation from '@/components/Navigation'

export default function DesignsLayoutClient({
  children,
}: {
  children: React.ReactNode
}) {
  const { isAuthenticated } = useAuthStore()
  const [isNavCollapsed, setIsNavCollapsed] = useState(false)

  // For authenticated users, show the navigation sidebar
  if (isAuthenticated) {
    return (
      <div className="h-screen bg-background flex overflow-hidden pt-14 relative">
        <Navigation
          isCollapsed={isNavCollapsed}
          onToggleCollapse={() => setIsNavCollapsed(!isNavCollapsed)}
        />
        <main className="flex-1 overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {children}
        </main>
      </div>
    )
  }

  // For unauthenticated users, show full-width content with top padding
  return <div className="pt-14">{children}</div>
}
